<script setup>
import {onMounted, ref} from 'vue';
import {useDataTable} from '@/utils/datatableHelper';
import {useToast} from "vue-toastification";
import {formatDate, showSuccessMessage} from '@/helper';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import ModalDialog from '@/components/modals/ModalDialog.vue';
import CreateEditFormModal from '@/components/modals/CreateEditFormModal.vue';
import FormService from '@/services/FormService';

import {useI18n} from 'vue-i18n'
import {authData} from '@/services/AuthService';
import DocumentService from "@/services/DocumentService";

const {t} = useI18n()

const props = defineProps({
  clientId: Number
});

const toast = useToast();

const isLoading = ref(false);
const datatable = useDataTable(fetchRecords, 'created_at', 10, true);
const rows = ref([]);
const columns = ref([
  {label: t('formsIndex.date'), field: 'created_at', sortable: false, filterOptions: {enabled: false}, formatFn: (value) => formatDate(value, 'd.m.Y H:i')},
  {label: t('formsIndex.template_name'), field: 'template_name', sortable: false},
  {label: t('formsIndex.status'), field: 'state', sortable: false},
  {label: t('formsIndex.action'), field: 'action', sortable: false},
]);

function fetchRecords(body) {
    body = {...body,...{filter: {client_id: props.clientId}}};
  FormService.fetchRecords(props.clientId, body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    rows.value = response.data;
  });
}

function viewForm(form) {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateEditFormModal, {form,  disabled: form.state !== 'CONCEPT'});
  reveal();
  onConfirm((data) => {
    data.client_id = props.clientId;
    data.creator_id = authData.loggedUser.id;
    FormService.saveForm(props.clientId, data).then(response => {
      showSuccessMessage(response.message);
      emitter.emit('formSaved');
      datatable.fetchWithValues();
    });
  });
  onCancel(() => {
  });
}

function deleteForm(form) {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(ModalDialog, {
    title: t('formsIndex.form_delete'),
    message: t('formsIndex.confirm_delete_entry'),
  });
  onConfirm(() => {
    FormService.deleteForm(props.clientId, form.id).then(() => {
      showSuccessMessage(t('formsIndex.form_is_deleted'));
      datatable.fetchWithValues();
    });
  });
  reveal();
}

onMounted(() => {
  emitter.on('formSaved', () => {
    datatable.fetchWithValues();
  });
})
</script>

<template>
  <div class="page-section">
    <div class="page-section__content">
      <div class="mt-3">
        <vue-good-table
            :columns="columns"
            :rows="rows"
            mode="remote"
            @page-change="datatable.onPageChange"
            @sort-change="datatable.onSortChange"
            @column-filter="datatable.onColumnFilter"
            @per-page-change="datatable.onPerPageChange"
            :totalRows="datatable.totalRecords.value"
            :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('formsIndex.entriesPerPage'),
                  nextLabel: t('formsIndex.next'),
                  prevLabel: t('formsIndex.previous'),
                  ofLabel: 'z',
                }">
          <template #table-row="props">
            <span v-if="props.column.field === 'state'">
            <span v-if="props.row.state === 'DENIED'"> {{ t('formsIndex.state_rejected') }} </span>
            <span v-if="props.row.state === 'APPROVED'"> {{ t('formsIndex.state_confirmed') }} </span>
            <span v-if="props.row.state === 'WAITING'"> {{ t('formsIndex.state_waiting_confirm') }} </span>
              <span v-if="props.row.state === 'TO_REVIEW'"> {{ t('formsIndex.state_to_review') }} </span>
            <span v-if="props.row.state === 'CANCELED'"> {{ t('formsIndex.state_canceled') }} </span>
            <span v-if="props.row.state === 'ACCEPTED'"> {{ t('formsIndex.state_accepted') }} </span>
            <span v-if="props.row.state === 'CONCEPT'"> {{ t('formsIndex.state_concept') }} </span>
          </span>
          <span v-if="props.column.field === 'action'">
            <span style="font-weight: bold; float: right">
              <button type="button" class="btn btn-link"><i @click="viewForm(props.row)" class="mdi mdi-eye"/></button>
              <button type="button" class="btn btn-error" @click="deleteForm(props.row)"><i class="mdi mdi-trash-can-outline"/></button>
            </span>
          </span>
          </template>
          <template v-slot:emptystate v-if="!isLoading">
            <div class="text-center">
              {{ t('formsIndex.no_records_found') }}
            </div>
          </template>
          <template v-slot:emptystate v-if="isLoading">
            <div class="text-center">
              {{ t('formsIndex.data_loading') }}
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
